export default {
    moveToClickFolder: {
        datapoint: {
            name: 'TnS_MoveToClickFolder',
            customData: function (actionSource) { return [actionSource]; },
        },
    },
    moveToCreateNewFolder: {
        datapoint: {
            name: 'TnS_MoveToCreateNewFolder',
            customData: function (moveToMenuActionSource, createNewActionSource) { return [moveToMenuActionSource, createNewActionSource]; },
        },
    },
    moveToViewAllFoldersClicked: {
        datapoint: {
            name: 'TnS_MoveToViewAllFolders',
            customData: function (actionSource) { return [actionSource]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map